import { Grid } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import React, { useEffect, useState } from 'react';
import {
  CardComponent,
  PageTitleAndSubTitle,
  ToggleGroup,
  Layers,
  SvgTable,
  ContractCard,
  TextField,
  ContractsTable,
  Contract,
  Reports,
  Document,
  Trash,
  Exclamation,
  ConfirmationPopup,
  Button,
  Archive,
  Edit,
  BasicModal,
  TypableDropdown,
  DatePicker,
  AutoComplete,
} from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import { AlertColor as MuiColor } from '@mui/material/Alert';
import Loader from '../../_components/molecules/Loader';
import { observer } from 'mobx-react';
import Snackbar from '../../_components/atoms/Snackbar';
import contractAIQConstants from '../../core-utils/messages/ContractAIQConstants';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import properties from '../../core-utils/properties';
import { useStores } from '../../stores';
import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';
import {
  SimpleSearch,
  Typography,
} from '@HomaHealth/ui-component-library/lib/_patient-access-components';
import {
  abbreviate,
  effectiveDateFormat,
  extractCompareAgreementDetails,
  // getFeaturesByServiceAgreement,
  getReportsByServiceAgreement,
} from '../../core-utils/helper-utils/contractAIQHelper';
import GifWithLabels from '@HomaHealth/ui-component-library/lib/_patient-access-components/molecules/GIFWithLabels';
import { CONTRACT_ONBOARDING } from '../../core-utils/routes';
import NoDocuments from '../../../public/Images/NoContracts.png';
import { formatDate } from '../../core-utils/helper-utils/helper';
import {
  getHealthCarePartners,
  getServiceAgreements,
  updateContract,
} from '../../core-utils/axios/compliance-assurance/contracts';
import {
  extractAndSaveMetadataForContract,
  extractAndSaveProvisionMatrix,
  getUrlsForServiceAgreement,
} from '../../core-utils/helper-utils/contractMetadataHelper';
import { extractReport } from '../../core-utils/helper-utils/contractReportHelper';

export interface contractAiqProps {}

type DocumentRow = {
  id: string;
  document: string;
  documentType: string;
  totalFiles: string;
  effectiveDate: string;
};

type ContractRow = {
  id: string;
  name: string;
  healthcarePartnerId?: string;
  type: string;
  serviceAgreementId?: string;
  totalFiles: number;
  effectiveDate: string;
  date: string;
  status?: string;
  selectedReports: string[];
  reports: string[];
  subrows: DocumentRow[];
  healthcarePartners?: string[];
};

const useStyles = makeStyles()({
  mainDiv: {
    width: '1182px',
    padding: '40px 0px 36px 63px',
  },
  titleSubtitle: {
    width: '1182px',
    marginBottom: '30px',
  },
  noContractsCard: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '32px 0px',
  },
  cardView: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
  },
  fieldsRow: {
    display: 'flex',
    gap: '24px',
    alignItems: 'center',
    marginBottom: '20px',
  },
});

const ContractAiq: React.FC<contractAiqProps> = observer(({}) => {
  //Constants
  const messages = contractAIQConstants.CONTRACTS;
  const { classes } = useStyles();
  const navigate = useNavigate();

  const employerGroupStore = useStores().employerGroupStore;
  const contractStore = useStores().contractAiqStore;
  const egNid = employerGroupStore?.employerGroupResponseData?.eg_nid[0];
  const employer =
    employerGroupStore?.employerGroupResponseData?.employer_group_name[0];

  const iconStyles = { height: '16px', width: '16px' };
  const toggleLeftStyles = {
    border: 'none',
    borderRight: '1px solid ' + patientAccessTheme.palette.grey[300],
    width: '100px',
  };
  const toggleRightStyles = {
    border: 'none',
    borderLeft: '1px solid ' + patientAccessTheme.palette.grey[300],
    width: '100px',
  };
  const contractColumns = [
    'Healthcare Partner',
    'Service Agreement Type',
    'Total Files',
    'Effective Date',
  ];
  const rowMenuItems = [
    {
      label: 'View Contract',
      icon: <Contract />,
    },
    {
      label: 'View Documents',
      icon: <Document color={patientAccessTheme.palette.text.highemphasis} />,
    },
    {
      label: 'View Reports',
      icon: <Reports />,
    },
    {
      label: 'Edit Contract',
      icon: <Edit color={patientAccessTheme.palette.text.highemphasis} />,
    },
    {
      label: 'Archive',
      icon: (
        <Archive
          width="22px"
          height="22px"
          fill={patientAccessTheme.palette.text.highemphasis}
        />
      ),
    },
    {
      label: 'Delete',
      icon: <Trash />,
    },
  ];
  const subRowMenuItems = [
    {
      label: 'View Document',
      icon: <Document />,
    },
    {
      label: 'Delete Document',
      icon: <Trash />,
    },
  ];
  const defaultContractRow: ContractRow = {
    id: '',
    name: '',
    type: '',
    totalFiles: 0,
    effectiveDate: '',
    date: '',
    status: '',
    healthcarePartners: [],
    selectedReports: [],
    reports: [],
    subrows: [],
  };

  //States
  const [loading, setLoading] = useState<boolean>(true);
  const [loader] = useState<any>(<Loader />);

  //Contracts
  const [toggleState, setToggleState] = useState<'left' | 'right'>('left');
  const [contracts, setContracts] = useState<any>([]);
  const [filteredContracts, setFilteredContracts] = useState<any>([]);
  const [popupState, setPopupState] = useState({
    isOpen: false,
    action: '', // 'archive', 'deleteContract', 'deleteDocument'
    title: '',
    subTitle: '',
    handleConfirm: () => {},
  });
  const [searchText, setSearchText] = useState('');
  const [editPopup, setEditPopup] = useState<boolean>(false);
  const [serviceAgreements, setServiceAgreements] = useState<any>([]);
  const [selectedContract, setSelectedContract] = useState<ContractRow>(
    defaultContractRow,
  );
  const [unFormatedContracts, setUnFormatedContracts] = useState<any>([]);

  //Archived Contracts
  const [archivedContracts, setArchivedContracts] = useState<any>([]);
  const [
    archivedFilteredContracts,
    setArchivedFilteredContracts,
  ] = useState<any>([]);

  const [snackbarState, setSnackbarState] = React.useState<{
    open: boolean;
    message: string;
    severity: MuiColor | undefined;
    duration: null | number;
  }>({
    open: false,
    message: '',
    severity: undefined,
    duration: null,
  });

  //Functions
  const handleOpenSnackBar = (
    message: string,
    severity: MuiColor,
    duration: number | null,
  ) => {
    setSnackbarState({
      open: true,
      message: message,
      severity: severity,
      duration: duration,
    });
  };

  const handleCloseSnackBar = (
    event?: React.SyntheticEvent,
    reason?: string,
  ) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbarState({
      open: false,
      message: '',
      severity: undefined,
      duration: null,
    });
  };

  const closePopup = () => {
    setPopupState((prev) => ({ ...prev, isOpen: false }));
  };

  const handleArchiveContract = async () => {
    await updateContract(
      egNid,
      contractStore.contractId,
      {
        status: 'Archive',
      },
      handleOpenSnackBar,
    );
    apiCalls();
    closePopup();
  };

  const handleDeleteContract = async () => {
    await deleteContractOrDocument(contractStore.contractId);
    closePopup();
  };

  const handleDeleteDocument = async () => {
    await deleteContractOrDocument(
      contractStore.contractId,
      contractStore.documentSelected,
    );
    closePopup();
  };

  const handleSearchChange = (event: any) => {
    setSearchText(event.target.value);
    const initialContracts = [...contracts];
    const filteredContracts = initialContracts?.filter((item: any) => {
      if (
        item?.name?.toLowerCase().includes(event.target.value?.toLowerCase())
      ) {
        return item;
      }
    });
    setFilteredContracts(filteredContracts);
  };

  const handleContractRowClick = (row: any) => {
    const selectedContractData = contracts.find(
      (temp: any) => temp?.id === row.id,
    );
    contractStore.setContractId(row.id);
    navigate('/contract-selected', {
      state: {
        contract: selectedContractData?.type,
        isDocumentView: false,
        healthcarePartner: selectedContractData?.name,
      },
    });
  };

  const handleRowMenuItemClick = async (row: any, menuItem: string) => {
    const selectedContractData = contracts.find(
      (temp: any) => temp?.id === row.id,
    );
    setSelectedContract(selectedContractData);

    contractStore.setContractId(row.id);
    const commonProps = {
      contract: selectedContractData?.type,
      healthcarePartner: selectedContractData?.name,
    };

    switch (menuItem) {
      case 'View Contract':
        navigate('/contract-selected', {
          state: {
            ...commonProps,
            isDocumentView: false,
          },
        });
        break;
      case 'View Documents':
        navigate('/contract-selected', {
          state: {
            ...commonProps,
            isDocumentView: true,
          },
        });
        break;
      case 'View Reports':
        navigate('/contract-selected', {
          state: {
            ...commonProps,
            isReportsTab: true,
          },
        });
        break;
      case 'Edit Contract':
        const serviceAgreementsData = await getServiceAgreements(
          handleOpenSnackBar,
        );
        setServiceAgreements(serviceAgreementsData);
        setEditPopup(true);
        break;
      case 'Archive':
        setPopupState({
          isOpen: true,
          action: 'archive',
          title: messages.ARCHIVE_CONTRACTS.TITLE,
          subTitle: messages.ARCHIVE_CONTRACTS.SUB_TITLE,
          handleConfirm: handleArchiveContract,
        });
        break;
      case 'Delete':
        setPopupState({
          isOpen: true,
          action: 'deleteContract',
          title: messages.DELETE_CONTRACTS.TITLE,
          subTitle: messages.DELETE_CONTRACTS.SUB_TITLE,
          handleConfirm: handleDeleteContract,
        });
        break;
      default:
        break;
    }
  };

  const handleSubRowMenuItemClick = async (
    row: any,
    subrow: any,
    menuItem: string,
  ) => {
    contractStore.setContractId(row.id);
    switch (menuItem) {
      case 'View Document':
        const selectedContractData = contracts.find(
          (temp: any) => temp?.id === row.id,
        );
        contractStore.setDocumentSelected(row.id);
        navigate('/contract-selected', {
          state: {
            contract: selectedContractData?.type,
            isDocumentView: true,
            healthcarePartner: selectedContractData?.name,
          },
        });
        return;
      case 'Delete Document':
        contractStore.setDocumentSelected(subrow.id);
        setPopupState({
          isOpen: true,
          action: 'deleteDocument',
          title: messages.DELETE_DOCUMENTS.TITLE,
          subTitle: messages.DELETE_DOCUMENTS.SUB_TITLE,
          handleConfirm: handleDeleteDocument,
        });
        return;
      default:
        return;
    }
  };

  const handleRowArchiveMenuItemClick = (row: any, menuItem: string) => {
    contractStore.setContractId(row.id);

    switch (menuItem) {
      case 'Delete':
        setPopupState({
          isOpen: true,
          action: 'deleteContract',
          title: messages.DELETE_CONTRACTS.TITLE,
          subTitle: messages.DELETE_CONTRACTS.SUB_TITLE,
          handleConfirm: handleDeleteContract,
        });
        break;
      default:
        break;
    }
  };
  const getFeaturesByServiceAgreement = (service_agreement_name: string) => {
    switch (service_agreement_name) {
      case 'Third-Party Administrator (TPA)':
      case 'Administrative Services Only (ASO) Provider':
        return [
          'Fees',
          'Key Terms Compilation',
          'Red Flags Check',
          'Missing Checks',
          'Summary of Findings',
        ];
      case 'Pharmacy Benefit Manager (PBM)':
        return [
          'Red Flags Check',
          'Missing Checks',
          // 'Key Terms Compilation'
        ];
      case 'Provider Network Access':
        return ['Red Flags Check', 'Missing Checks'];
      case 'Broker or Consultant':
        return ['Red Flags Check', 'Missing Checks'];
      case 'Stop-Loss Insurance Provider':
        return ['Stop loss', 'Red Flags Check', 'Missing Checks'];
      case 'Direct Contract Provider (or Group)':
        return ['Red Flags Check', 'Missing Checks'];
      default:
        return [];
    }
  };

  // Reusable handler for contract field changes
  const handleContractFieldChange = async (field: string, value: any) => {
    setSelectedContract((prev) => ({
      ...prev,
      [field]: value,
    }));
    switch (field) {
      case 'type':
        const serviceAgreementId = serviceAgreements?.find(
          (item: any) => item?.service_agreement_name === value,
        )?._id;
        const data = await getHealthCarePartners(
          egNid,
          serviceAgreementId,
          handleOpenSnackBar,
        );
        const reports = getAllContractReports(contracts, value) || [];
        setSelectedContract((prev: any) => ({
          ...prev,
          name: data[0]?.health_care_partner || '',
          reports: reports,
          date: '',
          selectedReports: [],
          helthcarePartners: data?.map(
            (item: any) => item?.health_care_partner,
          ),
        }));
        break;
      case 'name':

      default:
        break;
    }
  };

  const handleInputChange = async (field: string, value: string) => {
    setSelectedContract((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  // Extracts reports and features for a given service agreement
  const getReportsAndFeatures = (serviceAgreementName: string) => {
    const reports = getReportsByServiceAgreement(serviceAgreementName) || [];
    const features = getFeaturesByServiceAgreement(serviceAgreementName) || [];
    return { reports, features };
  };

  // Adds comparison report if a matching contract exists
  // const getAllContractReports = (
  //   allContracts: any[],
  //   serviceAgreementName: string,
  // ) => {
  //   const { reports, features } = getReportsAndFeatures(serviceAgreementName);

  //   const comparisonMap: Record<string, string> = {
  //     'Third-Party Administrator (TPA)': 'Stop-Loss Insurance Provider',
  //     'Administrative Services Only (ASO) Provider':
  //       'Stop-Loss Insurance Provider',
  //     'Stop-Loss Insurance Provider': 'Third-Party Administrator (TPA)',
  //   };

  //   const reportMap: Record<string, string> = {
  //     'Third-Party Administrator (TPA)': 'Comparison with Stop Loss Agreement',
  //     'Administrative Services Only (ASO) Provider':
  //       'Comparison with Stop Loss Agreement',
  //     'Stop-Loss Insurance Provider':
  //       'Comparison with Administrative Service Agreement',
  //   };

  //   const targetName = comparisonMap[serviceAgreementName];
  //   if (targetName) {
  //     const targetContract = allContracts?.find(
  //       (contract: any) => contract?.service_agreement_name === targetName,
  //     );
  //     if (targetContract) {
  //       reports.push(reportMap[serviceAgreementName]);
  //     }
  //   }

  //   return [...reports, ...features];
  // };

  const getAllContractReports = (
    allContracts: any[],
    serviceAgreementName: string,
  ) => {
    const { reports, features } = getReportsAndFeatures(serviceAgreementName);

    const comparisonMap: Record<string, string> = {
      'Third-Party Administrator (TPA)': 'Stop-Loss Insurance Provider',
      'Administrative Services Only (ASO) Provider':
        'Stop-Loss Insurance Provider',
      'Stop-Loss Insurance Provider': 'Third-Party Administrator (TPA)',
    };

    const reportMap: Record<string, string> = {
      'Third-Party Administrator (TPA)': 'Comparison with Stop Loss Agreement',
      'Administrative Services Only (ASO) Provider':
        'Comparison with Stop Loss Agreement',
      'Stop-Loss Insurance Provider':
        'Comparison with Administrative Service Agreement',
    };
    let comparisonReports: string[] = [];

    const targetName = comparisonMap[serviceAgreementName];
    if (targetName) {
      const targetContract = allContracts?.find(
        (contract: any) => contract?.service_agreement_name === targetName,
      );
      if (targetContract) {
        comparisonReports = [reportMap[serviceAgreementName]];
      }
    }
    // ✅ single deduped return
    return Array.from(new Set([...reports, ...features, ...comparisonReports]));
  };

  const formatContractsData = (data: any[]) => {
    return data?.map((item: any) => {
      const reports =
        item?.extractions
          ?.filter((extraction: any) => extraction?.type === 'Report')
          ?.map((extraction: any) => extraction?.extraction) || [];
      const features =
        item?.extractions
          ?.filter((extraction: any) => extraction?.type === 'Metadata')
          ?.map((extraction: any) => extraction?.extraction) || [];
      return {
        id: item?.contract_id,
        name: item?.health_care_partner_name,
        type: item?.service_agreement_name,
        totalFiles: item?.total_files,
        effectiveDate: effectiveDateFormat(item?.effective_date),
        date: item?.effective_date,
        status: item?.status,
        selectedReports: [
          reports?.length > 0 ? [...reports] : [...item?.reports],
          features?.length > 0 ? [...features] : [...item?.features],
        ],
        reports: item?.extractions
          ? [...reports, ...features]
          : getAllContractReports(
              unFormatedContracts,
              item?.service_agreement_name,
            ),
        healthcarePartners: [item?.health_care_partner_name],
         
        subrows: item?.documents?.map((doc: any) => ({
          id: doc?._id,
          document: doc?.document_name,
          documentType: doc?.document_type,
          totalFiles: '-',
          effectiveDate: effectiveDateFormat(doc?.document_effective_date),
        })),
      };
    });
  };

  //API calls
  const getAllContracts = async () => {
    await axios
      .post(
        properties.aiqBaseUrl +
          properties.contractBaseUrl +
          properties.getContracts,
        {
          eg_nid: egNid,
        },
      )
      .then((response) => {
        if (response.status === 200) {
          const data = response?.data?.data;
          setUnFormatedContracts(data);
          const contractsTableData = formatContractsData(data);
          setContracts(contractsTableData);
          setFilteredContracts(contractsTableData);
        }
      })
      .catch((error) => {
        handleOpenSnackBar(error.response?.data?.error, 'error', 6000);
      });
  };

  const getArchivedContracts = async () => {
    await axios
      .post(
        properties.aiqBaseUrl +
          properties.contractBaseUrl +
          properties.getContracts,
        {
          eg_nid: egNid,
          showArchive: true,
        },
      )
      .then((response) => {
        if (response.status === 200) {
          const data = response?.data?.data;
          const contractsTableData = formatContractsData(data);
          setArchivedContracts(contractsTableData);
          setArchivedFilteredContracts(contractsTableData);
        }
      })
      .catch((error) => {
        handleOpenSnackBar(error.response?.data?.error, 'error', 6000);
      });
  };

  const deleteContractOrDocument = async (
    contractId: string,
    documentId?: string,
  ) => {
    await axios
      .post(
        properties.aiqBaseUrl +
          properties.contractBaseUrl +
          properties.deleteContract,
        {
          contract_id: contractId,
          document_id: documentId,
        },
      )
      .then(async (response) => {
        if (response.status === 200) {
          handleOpenSnackBar(
            `${documentId ? 'Document' : 'Contract'} deleted successfully`,
            'success',
            5000,
          );
          apiCalls();
        }
      })
      .catch((error) => {
        handleOpenSnackBar(error.response?.data?.error, 'error', 6000);
      });
  };

  const apiCalls = async () => {
    await Promise.all([getAllContracts(), getArchivedContracts()]);
    setLoading(false);
  };

  //UseEffects
  useEffect(() => {
    if (!egNid) {
      return;
    }
    apiCalls();
  }, [egNid]);

  //Components
  const ContractCards = () => {
    return (
      <Grid className={classes.cardView}>
        {filteredContracts?.map((item: any, index: number) => {
          return (
            <Grid key={index}>
              <ContractCard
                title={item?.name}
                abbrevation={abbreviate(item?.type)}
                width="265px"
                height="211px"
                abbrevationStyles={{ top: '48%', position: 'absolute' }}
                subTitle={
                  item?.totalFiles +
                  ` document${item?.totalFiles > 1 ? 's' : ''}`
                }
                handleOnClick={() => {
                  handleContractRowClick({ id: item?.id });
                }}
                truncatedTitleWidth={'200px'}
              />
            </Grid>
          );
        })}
      </Grid>
    );
  };

  const TableAndCardView = () => {
    return toggleState === 'left' ? (
      <ContractsTable
        rowsData={filteredContracts}
        columns={contractColumns}
        showRowMenu={true}
        showSubRowMenu={true}
        handleRowClick={handleContractRowClick}
        handleRowMenuItemClick={handleRowMenuItemClick}
        handleSubRowMenuItemClick={handleSubRowMenuItemClick}
        rowMenuItems={rowMenuItems}
        subRowMenuItems={subRowMenuItems}
      />
    ) : (
      <ContractCards />
    );
  };

  const NoContracts = () => {
    return (
      <CardComponent
        title={''}
        body={
          <Grid className={classes.noContractsCard}>
            <GifWithLabels
              mainLabel={
                <Typography
                  fontSize="14px"
                  fontType="medium"
                  lineHeight="24px"
                  textColor={patientAccessTheme.palette.text.highemphasis}
                  margin="24px"
                >
                  {messages.NO_CONTRACTS}
                </Typography>
              }
              subLabel={
                <Button
                  label={messages.UPLOAD}
                  variant="contained"
                  height="37px"
                  width="auto"
                  onClick={() => {
                    navigate(CONTRACT_ONBOARDING);
                  }}
                />
              }
              gifUrl={NoDocuments}
            />
          </Grid>
        }
      />
    );
  };

  //Typography components
  const getTypography = (label: string, marginBottom: string = '0px') => {
    return (
      <Typography
        fontSize="12px"
        fontType="regular"
        lineHeight="24px"
        textColor={patientAccessTheme.palette.text.highemphasis}
        margin={`0px 0px ${marginBottom} 0px`}
      >
        {label}
      </Typography>
    );
  };

  return (
    <>
      {loading ? (
        loader
      ) : (
        <>
          <Grid className={classes.mainDiv}>
            <Grid className={classes.titleSubtitle}>
              <PageTitleAndSubTitle
                title={messages.CONTRACT_TITLE}
                subTitle={messages.CONTRACT_SUBTITLE}
                showDownloadButton={false}
                showQueryDataButton={false}
              />
            </Grid>
            {contracts?.length > 0 ? (
              <CardComponent
                title={
                  <TextField
                    placeholder={messages.SEARCH_CONTRACT}
                    height="40px"
                    width="324px"
                    startAdornment={
                      <SimpleSearch
                        height="20px"
                        width="20px"
                        stroke={patientAccessTheme.palette.text.lowemphasis}
                      />
                    }
                    showStartAdornment={true}
                    value={searchText}
                    onChange={handleSearchChange}
                  />
                }
                topRightItem={
                  false ? (
                    <ToggleGroup
                      leftValue={messages.TOGGLE_LABELS.tableView}
                      rightValue={messages.TOGGLE_LABELS.cardView}
                      leftIcon={<Layers style={iconStyles} />}
                      rightIcon={<SvgTable style={iconStyles} />}
                      setSelectedToggle={setToggleState}
                      toggleLeftSideStyles={toggleLeftStyles}
                      toggleRightSideStyles={toggleRightStyles}
                    />
                  ) : (
                    <></>
                  )
                }
                body={
                  <Grid style={{ marginTop: '24px' }}>
                    <TableAndCardView />
                  </Grid>
                }
              />
            ) : (
              <NoContracts />
            )}
            {archivedContracts?.length > 0 && (
              <CardComponent
                title={messages.ARCHIVED}
                mainGridStyles={{ marginTop: '32px' }}
                titleSubTitleMargin="12px"
                body={
                  <ContractsTable
                    rowsData={archivedFilteredContracts}
                    columns={contractColumns}
                    showRowMenu={true}
                    showSubRowMenu={false}
                    handleRowMenuItemClick={handleRowArchiveMenuItemClick}
                    rowMenuItems={[
                      {
                        label: 'Delete',
                        icon: <Trash />,
                      },
                    ]}
                  />
                }
              />
            )}
          </Grid>
          {popupState.isOpen && (
            <ConfirmationPopup
              handleCancel={closePopup}
              handleConfirm={popupState.handleConfirm}
              icon={<Exclamation width="38px" height="38px" />}
              title={popupState.title}
              subTitle={popupState.subTitle}
              buttonsType="error"
              width={
                popupState.action === 'deleteContract' ? '544px' : undefined
              }
              height={
                popupState.action === 'deleteContract' ? '280px' : undefined
              }
            />
          )}
          {
            <BasicModal
              open={editPopup}
              title={'Edit Contract'}
              body={
                <>
                  <Grid className={classes.fieldsRow}>
                    <Grid>
                      {getTypography('Service Agreement Type', '8px')}
                      <TypableDropdown
                        dropDownOptions={serviceAgreements?.map(
                          (item: any) => item?.service_agreement_name,
                        )}
                        dropDownValues={serviceAgreements?.map(
                          (item: any) => item?.service_agreement_name,
                        )}
                        placeholder={'Agreement Type'}
                        value={selectedContract?.type}
                        handleChange={async (event) => {
                          const value = event?.target?.value as string;
                          handleContractFieldChange('type', value);
                        }}
                        handleInputChange={() => {}}
                        height="36px"
                        width="260px"
                        hideTextField={true}
                      />
                    </Grid>
                    <Grid>
                      {getTypography('Healthcare Partner', '8px')}
                      <TypableDropdown
                        dropDownOptions={
                          selectedContract?.healthcarePartners || []
                        }
                        dropDownValues={
                          selectedContract?.healthcarePartners || []
                        }
                        placeholder={'Select'}
                        textFieldPlaceholder="Enter Healthcare Partner name"
                        value={selectedContract?.name}
                        handleChange={(event) => {
                          const value = event?.target?.value as string;
                          handleContractFieldChange('name', value);
                        }}
                        handleInputChange={(value) => {
                          handleInputChange('name', value);
                        }}
                        height="36px"
                        width="260px"
                      />
                    </Grid>
                  </Grid>
                  <Grid className={classes.fieldsRow}>
                    <Grid>
                      {getTypography('Effective Date', '8px')}
                      <DatePicker
                        selectedDate={formatDate(
                          selectedContract?.date,
                          'MM-DD-YYYY',
                        )}
                        handleChange={(date, value) => {
                          handleContractFieldChange('date', value);
                        }}
                        height="36px"
                        width="260px"
                        minDate={undefined}
                        maxDate={undefined}
                        format="MM-dd-yyyy"
                        placeholder="mm-dd-yyyy"
                      />
                    </Grid>
                    <Grid>
                      {getTypography('Analysis/Reports', '8px')}
                      <AutoComplete
                        width="260px"
                        height="36px"
                        options={selectedContract?.reports || []}
                        defaultValue={selectedContract?.selectedReports || []}
                        handleChange={(
                          event: any,
                          value: any,
                           
                          reason: any,
                           
                          details: any,
                        ) => {
                          handleContractFieldChange('selectedReports', value);
                        }}
                        placeholder={
                          selectedContract?.selectedReports?.length === 0
                            ? 'Select Analysis/Reports'
                            : ''
                        }
                      />
                    </Grid>
                  </Grid>
                </>
              }
              cancelButtonLabel={'Cancel'}
              confirmButtonLabel={'Update'}
              handleCancel={() => setEditPopup(false)}
              handleConfirm={async () => {
                const features = getFeaturesByServiceAgreement(
                  selectedContract?.type,
                );
                const existingContract = unFormatedContracts?.find(
                  (item: any) => item?.contract_id === selectedContract?.id,
                );
                const updatedContract = await updateContract(
                  egNid,
                  selectedContract?.id,
                  {
                    health_care_partner: selectedContract?.name,
                    service_agreement: selectedContract?.type,
                    effective_date: selectedContract?.date,
                    reports: selectedContract?.selectedReports?.filter(
                      (item) => !features?.includes(item),
                    ),
                    features: selectedContract?.selectedReports?.filter(
                      (item) => features?.includes(item),
                    ),
                  },
                  handleOpenSnackBar,
                );
                (async () => {
                  if (updatedContract) {
                    const {
                      reports: updatedReports = [],
                      features: updatedFeatures = [],
                      documents = [],
                      type,
                      _id: contractId,
                      service_agreement_name: newAgreementName,
                    } = updatedContract;

                    const oldReports = existingContract?.reports || [];
                    const oldFeatures = existingContract?.features || [];
                    const oldAgreementName =
                      existingContract?.service_agreement_name;

                    const agreementChanged =
                      newAgreementName !== oldAgreementName;

                    // Decide which reports and features to process
                    const reportsToProcess = agreementChanged
                      ? updatedReports
                      : updatedReports.filter(
                          (report: string) => !oldReports.includes(report),
                        );

                    const featuresToProcess = agreementChanged
                      ? updatedFeatures
                      : updatedFeatures.filter(
                          (feature: string) => !oldFeatures.includes(feature),
                        );

                    if (type === 'Base Document') {
                      const baseDocument = documents.find(
                        (doc: any) =>
                          doc?.document_type === 'Base Document' ||
                          doc?.document_type === 'Master Document',
                      );

                      const documentUrl = baseDocument?.document_url;

                      if (featuresToProcess?.length > 0) {
                        await extractAndSaveMetadataForContract(
                          egNid,
                          contractId,
                          newAgreementName,
                          documentUrl,
                          '',
                          getUrlsForServiceAgreement(
                            newAgreementName,
                            featuresToProcess,
                          ),
                        );
                      }

                      // Sequentially run extract for Provision Matrix
                      if (featuresToProcess.includes('Provision Matrix')) {
                        await extractAndSaveProvisionMatrix(
                          documentUrl,
                          contractId,
                          egNid,
                          newAgreementName,
                        );
                      }

                      // Sequentially run extract for each report
                      for (const report of reportsToProcess) {
                        const {
                          compareAgreementId,
                          compareUrl,
                        } = extractCompareAgreementDetails(
                          unFormatedContracts,
                          report,
                        );

                        await extractReport(
                          contractId,
                          documentUrl,
                          report,
                          egNid,
                          compareAgreementId,
                          compareUrl,
                          '',
                          false,
                          employer,
                        );
                      }
                    }
                  }
                })();

                await getAllContracts();
                setEditPopup(false);
              }}
              handleClose={() => setEditPopup(false)}
            />
          }
          <Snackbar
            {...snackbarState}
            handleClose={handleCloseSnackBar}
            vertical="bottom"
            horizontal="right"
          />
        </>
      )}
    </>
  );
});

export default ContractAiq;
